import { indexItems } from '@/mocks/home-data';

export default function IndexSection() {
  return (
    <section id="index" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-8">
          主题索引
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 hover:bg-background-50 transition-all cursor-pointer no-underline"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 flex-shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-bold text-foreground-950 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-1.5">{item.desc}</p>
                <span className="text-xs text-accent-600 font-medium">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}